<template>
    <div>
        <v-row class="px-5 mt-5" no-gutters> Form </v-row>
        <v-row class="pa-3" no-gutters>
            <v-row no-gutters class="mb-5">
                <v-col cols="auto mx-2">
                    <a-text-field clearable color="neutralGray" filled single-line dense label="Search" value="" prepend-inner-icon="mdi-magnify">
                    </a-text-field>
                </v-col>
                <v-col cols="auto mx-2">
                <!-- <div class="parentInput" v-cloak>
                    <input id="inputID" v-show="false" type="file" class="input"/>
                    <label for="inputID">
                    <v-icon class="mr-1" color="neutralGray1">mdi-attachment</v-icon>
                    click or drag and drop files here
                    </label>
                </div> -->
                <file-input/>
                </v-col>
                <v-col cols="auto mx-2">
                <div class="card-div">
                    <v-card-text>
                        <v-row no-gutters>
                            <a-text-field class="text-field" color="neutralGray" dense filled label="Text" value=""> </a-text-field>
                        </v-row>
                        <v-row no-gutters>
                        <a-text-field color="neutralGray" dense filled label="Text" value="Text"> </a-text-field>
                        </v-row> 
                        <v-row no-gutters>
                            <a-text-field color="neutralGray" hide-details="auto" dense filled label="Text" value="" required> </a-text-field>
                        </v-row>
                    </v-card-text>
                </div>
                </v-col>
                <v-col cols="auto mx-2">
                <div class="card-div">
                    <v-card-text>
                        <v-row no-gutters>
                            <a-autocompletes color="neutralGray" single-line dense filled label="Text" :items="items"> </a-autocompletes>
                        </v-row>
                        <v-row no-gutters>
                            <a-autocompletes color="neutralGray" dense filled label="Text" :value="items[1]" :items="items"> </a-autocompletes>
                        </v-row>
                        <v-row no-gutters>
                        <a-autocompletes color="neutralGray" hide-details="auto" dense filled label="Text" :items="items" required
                        :rules="[(v) => !!(v ? v.trim() : '') || 'Select an item']"> </a-autocompletes>
                        </v-row> 
                    </v-card-text>
                </div>
            </v-col>
            <v-col cols="auto mx-2">
                <div class="card-div">
                    <v-card-text>
                        <v-row no-gutters class="my-5">
                            <a-checkbox label=""></a-checkbox>           
                        </v-row> 
                        <v-row no-gutters class="my-5">
                            <a-checkbox label=""></a-checkbox>
                        </v-row> 
                    </v-card-text>
                </div>
            </v-col>
            <v-col cols="auto mx-2">
                <div class="card-div">
                    <v-card-text>
                        <v-radio-group>
                        <v-row no-gutters class="my-5">
                            <a-radio label=""></a-radio>           
                        </v-row>
                        <v-row no-gutters class="my-5">
                            <a-radio label=""></a-radio>           
                        </v-row>
                        </v-radio-group>
                    </v-card-text>
                </div>
            </v-col>           
            </v-row>
        </v-row>
        <v-row class="px-5 mt-5" no-gutters> List </v-row>
        <v-row class="pa-3" no-gutters>
        <v-col cols="auto mx-2">
            <div class="card-div p-3">
            <a-list>            
                <v-list-item
                    v-for="data in users"
                    :key="data.title"
                    color="primary"
                >
                    <v-list-item-avatar>
                        <v-img contain src="@/assets/images/NoPhotoIcon.png"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title v-text="data.title"></v-list-item-title>
                    <v-list-item-subtitle v-text="data.email"></v-list-item-subtitle>
                    </v-list-item-content>

                </v-list-item>        
            </a-list>
            </div>
        </v-col>
        <v-col cols="auto mx-2">
            <div class="card-div p-3">
            <a-list>            
                <v-list-item-group v-model="selectedListItem" color="primary">
                <v-list-item
                    v-for="data in list"
                    :key="data.title"
                    color="primary"
                >
                    <v-row>
                    <v-col cols="9">
                        <v-list-item-content>
                        <v-list-item-title v-text="data.title"></v-list-item-title>
                        <v-list-item-subtitle v-text="data.date"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-col>
                    <v-col cols="3" class="pl-5">
                        <v-row>
                        <v-list-item-action>
                        <v-list-item-icon>
                            <v-icon>  mdi-attachment </v-icon>
                            <v-list-item-action-text>4</v-list-item-action-text>
                        </v-list-item-icon>
                        </v-list-item-action>
                        </v-row>
                        <v-row></v-row>
                    </v-col>
                    </v-row>
                </v-list-item>
                </v-list-item-group>            
            </a-list>
            </div>
        </v-col>
        </v-row>
    </div>
</template>

<script>
// import ATextfield from "./ATextfield.vue";
import AAutocompletes from "./AAutocompletes.vue";
import ACheckbox from './ACheckbox.vue';
import ARadio from './ARadio.vue';
import AList from './AList.vue';
import FileInput from './FileInput.vue'
export default {
    components: { AAutocompletes, ACheckbox, ARadio, AList, FileInput },
    name: "FormListSample",
    data() {
        return {
            selectedListItem: 1,
            items: ['One', 'Two'],
            list: [
                {
                title: 'Jason Oner',
                date: '1/1/2023 9:00pm',
                isDoc: true
                },
                {
                title: 'Max Oner',
                date: '2/1/2023 8:30pm',
                isDoc: true
                },
                {
                title: 'John Oner',
                date: '3/1/2023 3:30pm',
                isDoc: true
                }
            ],
            selectedUser: 1,
            users: [
                {
                title: 'Jason Oner',
                email: 'jsonOnwer@1234gmil.com'
                },
                {
                title: 'Max Oner',
                email: 'maxOnwer@0987gmil.com'
                },
                {
                title: 'Zhao Oner',
                email: 'zhaoOnwer@134gmil.com'
                },
                {
                title: 'Alex Oner',
                email: 'alexOnwer@097gmil.com'
                }
            ]
        };
    },
}
</script>

<style scoped>
/* .parentInput {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 8px;
  border: dashed 1px #999999;
  border-radius: 4px;
}
::v-deep .input + label {  
  color: #999999;
  min-width: 100%;
  font-family: 'Noto Sans JP';
  font-weight: 400;
  font-size: 12px;
}
::v-deep .input:focus + label, .input + label:hover {
  cursor: pointer;
} */
</style>